module.exports = __webpack_public_path__ + "img/self-love-small.b96bbe04.jpg";